import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "svg-icon svg-icon-1"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Voir dans la pièce", -1);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_inline_svg = _resolveComponent("inline-svg");

  var _component_el_button = _resolveComponent("el-button");

  return _ctx.closeButton ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = function ($event) {
      return _ctx.$emit('close-modal');
    }),
    style: {
      "cursor": "pointer"
    }
  }, [_createElementVNode("span", _hoisted_1, [_createVNode(_component_inline_svg, {
    src: "/svg/icons/close.svg"
  })])])) : (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    onClick: _cache[1] || (_cache[1] = function ($event) {
      return _ctx.$emit('close-modal');
    }),
    type: "primary",
    plain: ""
  }, {
    default: _withCtx(function () {
      return [_hoisted_2];
    }),
    _: 1
  }));
}